// Form doğrulama kuralları (Aşama 2.2; vee 3.4.14'ün yerine). Davranış vee 3'ün `dist/rules` +
// varsayılan ayarlarıyla (bails, skipOptional, allowFalse) aynıdır:
// zorunlu kurallar önce çalışır, ilk hatada durulur; zorunlu olmayan alan boşsa diğer kurallar atlanır.
// Mesajlar clientapp'in (stellavue.js initValidation) çeviri anahtarlarıdır; çeviriyi çağıran verir.

export const MESSAGE_KEYS = {
  required: 'ValidationMessage.CannotBeEmpty',
  email: 'ValidationMessage.EmailIsNotValid'
};

const EMAIL_RE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const isNullOrUndefined = value => value === null || value === undefined;
const isEmptyArray = value => Array.isArray(value) && value.length === 0;

// vee 3 `required` (allowFalse: true): null/undefined/[] ve yalnız boşluktan oluşan metin geçmez; false ve 0 geçer.
export function required(value) {
  if (isNullOrUndefined(value) || isEmptyArray(value)) return false;
  return String(value).trim().length > 0;
}

// vee 3 `email` (multiple: false).
export function email(value) {
  if (Array.isArray(value)) return value.every(item => EMAIL_RE.test(String(item)));
  return EMAIL_RE.test(String(value));
}

const RULES = { required, email };
const REQUIRE_RULES = ['required'];

// vee 3'ün "boş" tanımı (skipOptional): null, undefined, '' ve [].
export function isEmpty(value) {
  return isNullOrUndefined(value) || value === '' || isEmptyArray(value);
}

// 'required|email', '' / null, { required: true, email: false } → kural adları (zorunlular önce).
export function parse(rules) {
  let names = [];
  if (typeof rules === 'string') {
    names = rules.split('|').map(rule => rule.split(':')[0].trim()).filter(Boolean);
  } else if (rules && typeof rules === 'object') {
    names = Object.keys(rules).filter(name => rules[name] !== false);
  }
  names.forEach(name => {
    if (!RULES[name]) throw new Error(`No such validator '${name}' exists.`);
  });
  names = names.filter((name, index) => names.indexOf(name) === index);
  return [...names.filter(name => REQUIRE_RULES.includes(name)), ...names.filter(name => !REQUIRE_RULES.includes(name))];
}

const identity = key => key;

// { valid, errors }: en fazla bir hata (bails); hata, başarısız kuralın anahtarının `translate` çıktısıdır.
export function validate(value, rules, translate = identity) {
  const names = parse(rules);
  const isRequired = names.some(name => REQUIRE_RULES.includes(name));
  if (!isRequired && isEmpty(value)) return { valid: true, errors: [] };
  const failed = names.find(name => !RULES[name](value));
  return failed ? { valid: false, errors: [translate(MESSAGE_KEYS[failed])] } : { valid: true, errors: [] };
}
